import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header'

const api = useAxiosCreate('base')

export async function listManagers(params) {
	const res = await api.get('/api/v2/managers/list', {
		params,
		headers: authHeader(),
	})
	return res.data
}

export async function getManager(id) {
	const res = await api.get(`/api/v2/managers/${id}`, {
		headers: authHeader(),
	})
	return res.data
}
